import { createAsyncThunk, createSlice, PayloadAction } from '@reduxjs/toolkit';
import { ErrorDto } from '../../../models/dtos/error.dto';
import { Errors } from '../../errors';
import getExtractRepository, { ServiceRequest, ServiceResponse } from './getExtract.repository';

type InitialState = {
  loading: boolean;
  data?: ServiceResponse[];
  error?: ErrorDto;
};

const initialState: InitialState = {
  loading: false,
  data: undefined,
  error: undefined,
};

export const getExtract = createAsyncThunk('getExtract', async (params: ServiceRequest): Promise<ServiceResponse[]> => {
  return await getExtractRepository(params).catch((error:any) => {
    throw error;
  });
});

const serviceSlice = createSlice({
  name: 'extract',
  initialState,
  reducers: {
    servicesReset: (state) => {
      state.loading = false;
      state.data = undefined;
      state.error = undefined;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getExtract.pending, (state) => {
      state.loading = true;
      state.data = [];
      state.error = undefined;
    });
    builder.addCase(
        getExtract.fulfilled,
      (state, action: PayloadAction<ServiceResponse[]>) => {
        state.loading = false;
        state.data = action.payload;
      },
    );
    builder.addCase(getExtract.rejected, (state, action) => {
      state.loading = false;
      state.error = Errors.getErrorDtoFromApiError(action.error);
    });
  },
});

export default serviceSlice.reducer;
export const { servicesReset } = serviceSlice.actions;
